module.exports = __webpack_public_path__ + "img/me-square-2.fafe1250.jpg";